import { Program } from '@coral-xyz/anchor'
import { Wallet } from '@coral-xyz/anchor/dist/cjs/provider'
import { Connection, PublicKey } from '@solana/web3.js'
import { getVaultTypeAccountPublicKey, Vault } from 'hedge-web3'

import VaultAccount from '../accounts/VaultAccount'
import VaultType from '../accounts/VaultType'

export default async (
  program: Program<Vault>,
  vaultPublicKey: PublicKey
): Promise<VaultAccount> => {
  const vaultData = await program.account.vault.fetch(vaultPublicKey)
  
  console.log("Found vault data", vaultData)
  console.log("Found vault data vaultAccount pubkey",  vaultData.vaultType.toString())


  if (!vaultData) {
    throw new Error('No Vault Found')
  }

  // Load Collateral Type
  const vaultTypeData = await program.account.vaultType.fetch(
    vaultData.vaultType
  )

  if (!vaultTypeData) {
    throw new Error('No Vault Type Found')
  }

  console.log("Found vault type data", vaultTypeData)

  const vaultType = new VaultType(vaultTypeData, vaultData.vaultType)
  const vault = new VaultAccount(vaultData, vaultPublicKey, vaultType)

  return vault
}
